import * as React from "react";
import { useLocation } from "react-router-dom";
import { authTokensContext } from "../context/authToken";
import { AuthTokenContextType } from "../@types/authToken";
import { getMetaFbc, getMetaFbp, initMetaExternalId } from "../utils/meta";

const MetaTrackingBootstrap = () => {
	const location = useLocation();
	const { user } = React.useContext(authTokensContext) as AuthTokenContextType;

	React.useEffect(() => {
		getMetaFbc();
		getMetaFbp();
	}, [location.search]);

	React.useEffect(() => {
		initMetaExternalId(user?.id);
	}, [user?.id]);

	return null;
};

export default MetaTrackingBootstrap;
